import { req } from 'api/init';
import { normalizePaginationResponse } from 'api/paginationCompat';
import axios from 'axios';

// 车辆费用明细
export const getVehivleFeePage = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/vehicleBIReportBO.ajax?cmd=getVehivleFeePage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 订单费用明细
export const orderFeeDetailReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/orderFeeDetailReportBO.ajax?cmd=queryOrderFeeDetail',
    method: 'post',
    data,
  }).then(async (res) => {
    // 注：返回的格式不是正常的列表格式，没有页码总数之类的，反正无法渲染，旧版也一样
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 运营明细报表 - 自营/外发订单费用
export const orderOperateDetailReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/orderOperateDetailReportBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车队运营报表
export const tenantOperateReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=tenantOperateReport',
    method: 'post',
    data,
  }).then(async (res) => {
    // 注：返回的格式不是正常的列表格式，没有页码总数之类的，反正无法渲染，旧版也一样
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 出车打款报表明细
export const outCarFeeReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=outCarFeeReport',
    method: 'post',
    data,
  }).then(async (res) => {
    // 注：返回的格式不是正常的列表格式，没有页码总数之类的，反正无法渲染，旧版也一样
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 出车打款报表 - 打印 - 图片预览查询
export const getOrderMoneyTypeAttach = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=getOrderMoneyTypeAttach',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(normalizePaginationResponse(res, ['picFullUrl']));
  }).catch((err) => {
    reject(err);
  });
});

// 资产报表
export const getAssetsReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/ac/license/reportConfigBO.ajax?cmd=getDetailsRepayment',
    method: 'post',
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 应收报表
export const getReceivableReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/ac/receivable/reportConfigBO.ajax?cmd=getReceivableStatementMonth',
    method: 'post',
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 部门运营月报表
export const orgMonthlyReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=orgMonthlyReport',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 部门运营日报表
export const orgDateReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=orgDateReport',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机运营月报
export const driverOperateReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=queryDriverOperateReportStat',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机运营月报 -列表 -明细
export const queryDriverOperateReportDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/reportActionBO.ajax?cmd=queryDriverOperateReportDetail',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆运营月报
export const vehicleMonthlyReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=vehicleMonthlyReport',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户月报
export const custMonthlyReport = async (data) => new Promise((resolve, reject) => {
  req({
    url: '/reportActionBO.ajax?cmd=custMonthlyReport',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
